import { render } from "./satu.vue?vue&type=template&id=07c03996&scoped=true"
import script from "./satu.vue?vue&type=script&lang=js"
export * from "./satu.vue?vue&type=script&lang=js"

import "./satu.vue?vue&type=style&index=0&id=07c03996&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c03996"]])

export default __exports__